export default __webpack_public_path__ + "static/FReg-4x3-JG-84ba8371c7bcbfe5db4b61380fa0da67.jpg";